/* eslint-disable jsx-a11y/anchor-is-valid */
import { AxiosError, AxiosResponse } from "axios";
import moment from "moment";
import React, { useContext, useEffect } from "react";
// import { BankUserContext } from "../../bankUserContext";
// import {
//   Message,
//   MessageThread,
// } from "../../Models/MessageCenter/MessageThread";
// import CustomerService from "../../Services/CustomerService";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as PDFImage } from "../../../images/MessageCenter/pdf.svg"
import { ReactComponent as PDFWhiteImage } from "../../../images/MessageCenter/pdf-white.svg";
import FileViewer from "react-file-viewer";
import "./messageCenter.scss";
import { Modal } from "reactstrap";
import { ModalHeader } from "reactstrap";
import { ModalBody } from "reactstrap";
import { Row } from "reactstrap";
import { Col } from "reactstrap";
// import SpinnerModel from "../../commonFields/SpinnerModel";
// import { catchError } from "../../Utils/Utils";
import DocSaveIcon from "../../Images/DocSaveIcon.svg";
// import SaveDocumentModal from "../MessageCenter/SaveDocumentModal";
import GreenCheckMark from "../../Images/GreenCheck.svg";
import { toast } from "react-toastify";
import './messageCenter.scss';
import { Message, MessageThread } from "../../../models/QuestionarieMCModal";
import { LeadDetailsModel } from "../../../models/Lead/LeadDetails";
import { BankUserContext } from "../../../bankUserContext";
import SpinnerModel from "../../../commonfields/SpinnerModel";
import { catchError } from "../../../utils/Utils";
import SaveDocumentModal from "../SaveDocumentModal";
import Service from "../../../services";
// import LeadDetailsModel from '../../Models/Lead/LeadDetailsModel';
// import RolesAuthentication from "../../Utils/RolesUtlis";

export interface MessageChatProps {
  messageThread?: MessageThread | null | undefined,
  refreshCounter: number,
  summaryReport?: boolean;
  clientDetails?: LeadDetailsModel | null;
}
// const locationsData = [
//   { text: "General", value: "general" },
//   { text: "Organization", value: "organization" },
// ];

const MessageChatWindowFC: React.FC<MessageChatProps> = (
  props: MessageChatProps
) => {
  const [messages, setMessages] = React.useState<Message[]>([]);
  const service = new Service();
  const bankUserContext = useContext(BankUserContext);
  const [loading, setLoading] = React.useState(false);
  const [fileViewerToShow, setFileViewerToShow] = React.useState(false);
  const [currentFile, setCurrentFile] = React.useState<{
    name: string;
    file: any;
    fileType: string;

  }>();
  const [readMore, setReadMore] = React.useState(false);
  const [allClinetsData, setAllClinetsData] = React.useState([]);
  const [showDocumentModal, setShowDocumentModal] = React.useState(false);
  const [selectedClientId, setSelectedClientId] = React.useState("");
  const [isSavedDoc, setIsSavedDoc] = React.useState<boolean>(false);
  const [filePath, setFilePath] = React.useState<string>("");
  const [locationsData, setLocationData] = React.useState<any>([]);
  // const roles=new RolesAuthentication();

  const showFilePreview = (m: any) => {
    setLoading(true);
    service
      .downloadAttachment(m.attachmentPath, m.fileId)
      .then((res: any) => {
        if (res?.data) {
          let fileType = "";
          const ind = m.message.lastIndexOf(".");
          if (ind > -1) {
            fileType = m.message.slice(ind + 1).toLowerCase();
          }
          setCurrentFile({
            name: m.message,
            file: res.data,
            fileType,
          });
          setFileViewerToShow(true);
        }
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };
  moment.locale("en", {
    calendar: {
      lastDay: "[Yesterday] LT",
      sameDay: "[] LT",
      lastWeek: "L LT",
      sameElse: "L LT",
    },
  });

  const fileViewerHandler = () => {
    setFileViewerToShow(!fileViewerToShow);
  };
  const showDocumentHandler = (m: Message) => {
    // service.getAllORClientIds().then((response: any) => {
    //   const data = response.data.map((element: any) => {
    //     return {
    //       text: `${element.firstName + " " + element.lastName + " - " + element.shortCode}`,
    //       value: element.clientId,
    //     };
    //   });
    //   setAllClinetsData(data);
    // });
    // service.checkUserRoleMsgThread(m.createdBy, m.sentTo) .then((response: any) => {
    //     if (response.status === 200) {
    //       setSelectedClientId(response.data.clientId ?? "");
    //       if(response.data.clientId){
    //       service.getLocations(response.data.clientId).then((res: any) => {
    //         if (res.status === 200) {
    //           const locData = res.data.map((element: any) => {
    //             return {
    //               text: element,
    //               value: element,
    //             };
    //           });
    //           setLocationData(locData);
    //         }
    //       });
    //     }
    //     }
    //   });
    //   setFilePath(m.attachmentPath);
    // setShowDocumentModal(true);
  }
  const closeSaveDocumentModalHandler = () => {
    setShowDocumentModal(false);
  }
  const onDocSaveHandler = (data: any) => {
    // const body = {
    //   docTitle: data?.docTitle,
    //   location: data?.location,
    //   clientUUID: data?.clientUUID,
    //   filePath: filePath,
    // };
    // service.saveMessageDocument(body).then((response: any) => {
    //   setShowDocumentModal(false);
    //   if (response.status === 202) {        
    //     setIsSavedDoc(true);
    //   }else {
    //     toast.error("Something went wrong.");
    //   }
    // });
  };

  const loadLoctionsdata = (clinetId: string) => {
    // clinetId && service.getLocations(clinetId).then((res: any) => {
    //   if (res.status === 200) {
    //     const locData = res.data.map((element: any) => {
    //       return {
    //         text: element,
    //         value: element,
    //       };
    //     });
    //     setLocationData(locData);
    //   }
    // });
  }

  const getUserName = (m: Message) => {
    if (m.createdBy == bankUserContext?.bankuserDetails?.userId) {
      return bankUserContext?.bankuserDetails?.firstName + " " + bankUserContext?.bankuserDetails?.lastName;
    }
    else {
      return props.clientDetails?.firstName + " " + props.clientDetails?.lastName;
    }
  }

  const displayMessage = (m: Message) => {
    return (
      <>
        {/* {showDocumentModal && (
        <SaveDocumentModal
          showDocumentHandler={showDocumentHandler}
          closeSaveDocumentModalHandler={closeSaveDocumentModalHandler}
          allClinetsData={allClinetsData}
          locationsData={locationsData}
          selectedClientId={selectedClientId}
          onDocSaveHandler={onDocSaveHandler}
          loadLoctions={loadLoctionsdata}
        />
      )} */}
        <div className="messageTime">{moment(m.createdAt).calendar()}</div>
        {m.createdBy !== bankUserContext?.bankuserDetails?.userId ? (
          <div className="senderName">
            {`${m?.userDisplayFirstName || "--"} ${m?.userDisplayLastName}`}
          </div>
        ) : (
          <></>
        )}
        {m.messageType === "attachment" ? (
          <>
            <div className="fileNameDiv">
              <span className="message message-attachment box red arrow-right-bottom">
                <a onClick={() => showFilePreview(m)} className="fileDownload">
                  {/* <FontAwesomeIcon icon={faFilePdf} /> */}
                  {m?.createdBy === bankUserContext?.bankuserDetails?.userId ? (
                    <PDFWhiteImage className="pdf-white-image" />
                  ) : (
                    <PDFImage className="pdf-image" />
                  )}
                  &nbsp;{m.message}
                </a>
              </span>
              {/* <img
                src={DocSaveIcon}
                alt="DocSaveIcon"
                className={"docSaveIcon"}
                onClick={() => showDocumentHandler(m)}
              /> */}
              {/* {isSavedDoc && (
              <img
                src={GreenCheckMark}
                alt="checkMarkIcon"
                className="checkMark"
              />
            )} */}
            </div>
          </>
        ) : (
          <div className="message box red arrow-right-bottom">{m.message}</div>
        )}
        {/* <div className='messageTime'>{props.summaryReport && `${getUserName(m)} - `}
        {moment(m.createdAt).calendar()}</div>3
        {m.messageType === "attachment" ? <div className='message message-attachment box red arrow-right-bottom'>
          <a onClick={() => showFilePreview(m)} className="fileDownload" >
            <FontAwesomeIcon
            icon={faFilePdf}
            />&nbsp;{m.message}
          </a>
        </div> : <div className='message box red arrow-right-bottom'>
          {m.message}
        </div>} */}
      </>
    );
  };
  useEffect(() => {
    const id = props?.messageThread?.id;
    id &&
      service.getMessages(id).then((resp: AxiosResponse<Message[]>) => {
        setMessages(resp.data);
      });
    // service.getAllManualTodoUsers().then((response: any) => {
    //   const data = response.data.map((element: any) => {
    //     return {
    //       text: `${element.firstName + " " + element.lastName}`,
    //       value: element.userId,
    //     };
    //   });
    //   setAllClinetsData(data);
    // });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.messageThread?.id, props?.refreshCounter]);
  return (
    <>
      {loading && (
        <SpinnerModel value={""} color={"primary"} size={""} type={"border"} />
      )}

      <div className="chatBoxContainer">
        <ul className="messageList">
          {messages && messages.length ? (
            messages.map((m) =>
              bankUserContext?.bankuserDetails?.userId === m.createdBy ? (
                m.message ? (
                  <li className="m-right messageContainer">
                    {displayMessage(m)}
                  </li>
                ) : (
                  ""
                )
              ) : m.message ? (
                <li className="m-left messageContainer">{displayMessage(m)}</li>
              ) : (
                ""
              )
            )
          ) : props?.messageThread?.id ? (
            <p className="center">
              You&apos;re starting a new conversation. Type your first message
              below.
            </p>
          ) : (
            <p className="center">
              There are no messages available to display
            </p>
          )}
        </ul>
      </div>
      <div className="fileViewerModalContainer">
        <Modal
          className=" mw-100 w-50 fileViewerModalWrapper messageCenterFileView"
          isOpen={fileViewerToShow}
          fade={false}
          toggle={fileViewerHandler}
        >
          <ModalHeader toggle={fileViewerHandler}>
            <Row className="customHeader modal-title">
              <Col>
                <div
                  className={`fileHeader ${readMore ? "expand" : "contract"}`}
                  onClick={() => setReadMore((prev) => !prev)}
                >
                  {currentFile?.name}
                </div>
              </Col>
            </Row>
            <Row></Row>
          </ModalHeader>
          <ModalBody>
            <div className="TC_fileView">
              {currentFile ? (
                <FileViewer
                  fileType={currentFile?.fileType}
                  filePath={`data:application/${currentFile?.fileType};base64,${currentFile?.file?.image}`}
                />
              ) : (
                ""
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default MessageChatWindowFC;
